export default __webpack_public_path__ + "static/media/Knop.e243b811.svg";